export const THEME_LIGHT = "json-viewer-light";
